const hasExplicitTimezone = (s: string) => /[zZ]|[+-]\d{2}:?\d{2}$/.test(s);

export const ensureUtcSuffix = (s: string): string => {
  if (!s) return s;
  return hasExplicitTimezone(s) ? s : `${s}Z`;
};

export const parseDateUtcIfNoZone = (s: string): Date => {
  const iso = ensureUtcSuffix(s);
  const d = new Date(iso);
  return isNaN(d.getTime()) ? new Date(s) : d;
};

export const formatInChicago = (input: string | Date): string => {
  const d = typeof input === "string" ? parseDateUtcIfNoZone(input) : input;
  if (isNaN(d.getTime())) return typeof input === "string" ? input : "";
  return d.toLocaleString("en-US", {
    timeZone: "America/Chicago",
    timeZoneName: "short",
  });
};
